import isDeepLink from "owa-url/lib/isDeepLink";

export default function isPopout(targetWindow: Window | undefined): boolean {
    const isProjection = targetWindow && targetWindow !== window;
    return isDeepLink() || !!isProjection;
}
